<template>
  <div class="empty-layout">
    <img src="@/assets/logo.svg" alt="logo" />

    <router-view></router-view>
  </div>
</template>
